const DEFAULT_SITE_URL = "https://parvatiistays.pages.dev";

export const SITE_NAME = "ParvatiiStays";
export const SITE_URL = (import.meta.env.VITE_SITE_URL || DEFAULT_SITE_URL).replace(/\/+$/, "");
export const DEFAULT_OG_IMAGE = "/og-image.jpg";
export const DEFAULT_KEYWORDS =
  "Boutique Airbnb management Sydney, short-term rental management Sydney, Northern Beaches Airbnb management, Mosman Airbnb co-host, Lower North Shore STR management, Eastern Suburbs Airbnb management, Sydney CBD short-term rental manager";

export const toAbsoluteUrl = (path = "/") => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${normalizedPath}`;
};
